export const ApiUrl = {
  // Leading slashes matter: with an absolute API base axios joins either
  // way, but under the local dev proxy (empty base) a bare path resolves
  // relative to the page, so `/invited/signup/<token>` would request
  // `/invited/signup/organization_users/...` and 404.
  authModule: {
    user_signin: `/users/login/`,
    user_logout: `/users/logout/`,
    user_refresh_token: `/users/refresh_token/`,
    user_signup: `/users/sign_up/`,
    invintee_signup: `/organization_users/invitee_sign_up/`,
    user_verify: `/users/verify_user/`,
    forgot_password: `/users/forgot_password/`,
    reset_password: `/users/reset_password/`,
    get_token_data: `/organization_users/get_token_data/`,
  },
  objectiveModule: {
    all_objectives: `/all-objective/`,
    get_objectives: `/objective/`,
    get_condition: `/objective/`,
    add_objective: `/objective/`,
    update_objective: `/objective/`,
    get_responsible_persons: `/objective/list_responsible_persons/`,
    add_condition: `/objective/`,
    update_condition: `/objective/`,
    delete_condition: `/objective/`,
    delete_objective: `/objective/`,
    objective_archive: `objective/archive/`,
  },
  prioritiesModule: {
    get_priorities: `/prioritized-task/`,
    get_actions: `/actions/`,
    priority_archive: `/prioritized-task/archive/`,
    update_priority: `/prioritized-task/`, // Not used
    add_priority: `/prioritized-task/`,
    edit_priority: `/prioritized-task/`, // Not used
    delete_priority: `/prioritized-task/`,
    get_comments: `/comments/`,
  },
  actionCommentModule: {
    get_comments: `/action_comment/`,
    add_comment: `/action_comment/`,
  },
  radicalFocusActionModule: {
    get_actions: `/actions/list_radical_focus_actions/`,
    add_radical_action: `/actions/`,
    update_radical_action: `/actions/`,
    delete_radical_action: `/actions/`,
    archive_action: `/actions/archive/`,
    retrive_action: `/actions/`,
  },
  kpiModule: {
    common_base: `/kpi/`,
    get_kpis: `/kpi/`,
    get_reporting_kpis: `/kpi-reporting/`,
    get_absolute_kpis: `/kpi/absolute_kpi_list/`,
    get_calender: `/calender_manager/list_calender_by_frequency/`,
    add_kpi: `/kpi/`,
    daily_calender: `/calender_manager/list_calender_weeks/`,
    update_kpi: `/kpi/`,
    get_frequency_absolute_kpi: `/kpi/`,
    upadte_frequency_absolute_kpi: `/kpi/`,
    update_reporting_user: `/kpi/`,
    get_KPI_details: `/kpi/`,
    kpi_upload: `/kpi-upload/`,
    kpi_order_update: `/kpi/update_kpi_order/`,
  },
  commentModule: {
    get_comments: `/comment/`,
  },
  shareholder: {
    default: "/shareholder/",
    companyList: "/shareholder/list_companies/",
  },
  usersModule: {
    get_users: `/organization_users/`,
    get_reporting_users: `/organization_users/list_reporting_persons/`,
    get_responsible_persons: `/organization_users/list_reporting_persons/`,
    get_roles: `/roles/`,
    get_divisions: `/divisions/`,
    add_user: `/organization_users/`,
    add_role: `/roles/`,
    add_division: `/divisions/`,
    update_user_status: `/organization_users/`,
    delete_user: `/organization_users/`,
    reinvite_user: `/organization_users/`,
    success_manager: `/success_manger_company/`,
    update_user_profile: `/organization_users/update_user_profile/`,
    get_user_profile: `/organization_users/user_profile/`,
  },
  initiativeModule: {
    common_initiative_base: `/initiative/`,
    get_initiatives: `/initiative/`,
    add_initiative: `/initiative/`,
    update_initiatives: `/initiative/`,
    delete_initiatives: `/initiative/`,
    edit_initiative_action: `/initiative/`,
    get_initiative_details: `/initiative/`,
    list_initiative_actions: `/initiative/`,
  },
  initiativeTrackingModule: {
    get_initiative_trackings: `/initiative-tracking/`,
  },
  reporteeTrackerModule: {
    get_list_reportee: `/reportee-tracker/`,
  },
  kpiReportingModule: {
    get_list_reportee: `/kpi-reporting/`,
    get_kpi_reports: `/kpi-reporting/`,
  },
  processModule: {
    common_process_base: `/process/`,
    process_overview_list: `/process-overview/list_processes/`,
  },
  recurringActivityModule: {
    common_recurring_activity_base: `/recurring-activity/`,
    activity_overview_list: `/recurring-activity-overview/list_recurring_activities/`,
  },
  documentModule: {
    common_document_base: `/document/`,
  },
  forecastModule: {
    common_forecast_base: `/forecast/`,
  },
  ReviewModule: {
    common_review_base: `/review/`,
    get_list_objectives: `/review/list_objectives/`,
    get_forecast: `/review/fetch_forecast_data/`,
    get_actions: `/review/list_review_actions/`,
    create_highlight_lowlight: `/review/create_highlight_lowlight/`,
    create_review_actions: `/review/create_review_action/`,
    update_review_settings_order: `/update_review_settings_order/`,
  },
  planningModule: {
    common_planning_base: `/planning/`,
  },
  feedbackModule: {
    common_base: `/feedback_rating/`,
  },
  feedbackSettingModule: {
    common_base: `/feedback_settings/`,
  },
  valuePrincipleModule: {
    common_base: `/value_principles/`,
    create_value_path: `/value_principles/create_value/`,
    create_principle_path: `/value_principles/create_principle/`,
    list_values_path: `/value_principles/list_values/`,
  },
  generalSettingsModule: {
    common_base: `/general-settings/`,
  },
  pagePermissionModule: {
    common_base: `/page_permission/`,
  },
  businessModelModule: {
    canvas: {
      path: `/business_model/`,
    },
    things_master: {
      path: `/things_master/`,
    },
    createTriggerQue: "/things_master/create_trigger_question/",
  },
  trendsModule: {
    path: `/trends/`,
  },
  addressableMarket: {
    path: `/addressable_market/`,
  },
  offerBenchmark: {
    path: `/offer_benchmark/`,
  },
  positioning: {
    path: `/positioning/`,
    createCompetitor: "/positioning/create_competitor/",
    createPositioning: "/positioning/create_positioning/",
    updatePositioning: "/positioning/update_positioning/",
  },
  customerSegment: {
    valueProposition: `/value_proposition/`,
    createCustomerSegment: `/value_proposition/create_customer_segment/`,
    createDescription: `/value_proposition/create_description/`,
    customerSegmentation: `/customer_segmentation/`,
    createPositioning: `/customer_segmentation/create_positioning/`,
    updatePositioning: `/customer_segmentation/update_positioning/`,
    createCustomer: `/customer_segmentation/create_customer/`,
  },
  menuSetting: {
    getStructure: "/menu-structure/",
  },
  brand: {
    getList: "/brand/",
  },
  reportsModule: {
    common_base: `/report/`,
    list_reports: "/report/list_reports/",
    update_report_order: "/report/update_report_order/",
  },
  meetingScheduleModule: {
    common_base: `/meeting-schedule/`,
    meeting: `/meeting/`,
    update_meeting_schedule_order:
      "/meeting-schedule/update_meeting_schedule_order/",
  },
  columnPreferencesModule: {
    base: `column_preferences/`,
    restore_defaults: `column_preferences/restore_defaults/`,
    save_preferences: `column_preferences/save_preferences/`,
  },
  archiveModule: {
    unarchive: `/unarchive/`,
  },
  listingOrderModule: {
    base: `listing_order/`,
    update_order: `listing-order/update_order/`,
  },
  tagsModule: {
    base: `/tags/`,
    assignments: `/tags/assignments/`,
    assignmentsLookup: `/tags/assignments/lookup/`,
  },
};
